module.exports = __webpack_public_path__ + "img/BOTH.aef69cab.jpg";